/**
 * @version GENERATOR_VERSION::20200504
 * @DateTime 2021-04-23T14:56:33.689
 * @Author <a href=\"mailto:bigmouthz@foxmail.com\">bigmouthz</a>
 **/
import BasicLayout from '@/layouts/basic-layout';

const meta = {
	auth: true
};

const pre = 'rentmanage-RentGoodsSort-'

export default {
	path: '/rentmanage/rentgoodssort',
	name: 'rentmanage-RentGoodsSort',
	redirect: {
		name: '${pre}-index'
	},

	meta: {
		...meta,
	},

	component: BasicLayout,
	children: [{
			path: 'index',
			name: '${pre}RentGoodsSort-index',

			meta: {
				...meta,
				title: '物品分类'
			},

			component: () => import('@/pages/rentmanage/rentgoodssort/index'),
		},
		{
			path: 'detail-edit/:id',
			name: '${pre}RentGoodsSort-detail-edit',
			auth: [
				'hidden'
			],

			meta: {
				...meta,
				title: '物品分类编辑'
			},

			component: () => import('@/pages/rentmanage/rentgoodssort/detail-edit'),
		},
		{
			path: 'detail-edit',
			name: '${pre}RentGoodsSortdetail-create',
			auth: [
				'hidden'
			],

			meta: {
				...meta,
				title: '物品分类新增'
			},

			component: () => import('@/pages/rentmanage/rentgoodssort/detail-edit'),
		},
		{
			path: 'detail-view/:id',
			name: '${pre}RentGoodsSortView',
			auth: [
				'hidden'
			],

			meta: {
				...meta,
				title: '物品分类详情查看'
			},

			component: () => import('@/pages/rentmanage/rentgoodssort/detail-view'),
		},
	]
};
